import {IEventDispatcher} from "./ievent-dispatcher";

export class EventDispatcher implements IEventDispatcher {
  private readonly _eventListenerDataMap: Object;

  constructor() {
    this._eventListenerDataMap = {};
  }

  public addEventListener(event: string, listener: any, context: any = null): void {
    // TODO: improve this. keep array of {listener, context} objects?
    this._eventListenerDataMap[event] = this._eventListenerDataMap[event] || {
      listeners: [],
      contexts: []
    };

    if (this._eventListenerDataMap[event].listeners.indexOf(listener) === -1) {
      this._eventListenerDataMap[event].listeners.push(listener);
      this._eventListenerDataMap[event].contexts.push(context);
    }
  }

  public removeEventListener(event: string, listener: any): void {
    let listenerIndex: number = this._eventListenerDataMap[event] ? this._eventListenerDataMap[event].listeners.indexOf(listener) : -1;
    if (listenerIndex !== -1) {
      this._eventListenerDataMap[event].listeners.splice(listenerIndex, 1);
      this._eventListenerDataMap[event].contexts.splice(listenerIndex, 1);
    }
    if (!this._eventListenerDataMap[event].listeners.length) {
      delete this._eventListenerDataMap[event];
    }
  }

  public removeAllListeners(event: string): void {
    delete this._eventListenerDataMap[event];
  }

  public dispatchEvent(event: string, ...args: any[]): void {
    if (this._eventListenerDataMap[event]) {
      for (let i: number = 0, l: number = this._eventListenerDataMap[event].listeners.length; i < l; ++i) {
        this._eventListenerDataMap[event].listeners[i].apply(this._eventListenerDataMap[event].contexts[i], args);
      }
    }
  }
}
